import React, {useState} from "react";


const InfoCard = (props) => {

  const [openSteps, setOpenSteps] = useState(false);

  return(
    <div className={`need-know-item ${openSteps && "content-shown"}`} id={`#${props.key}`} key={props.key}>
      <h3 
            onClick={(newOpen) => {
                (openSteps) ?
                    setOpenSteps(!newOpen)
                :
                    setOpenSteps(newOpen)
            }}
            className="item-action-container"
        >
            <div className={`item-title ${openSteps && "selected"}`}>
                {props.title}
            </div>
            {(openSteps) ? 
                <img 
                    src="https://cdn.vostro.app/cdn/hotspots/base/icon arrow up.svg" 
                    alt="minus-icon" 
                    className="minimize-expand-icon"
                /> 
                :
                <img 
                    src="https://cdn.vostro.app/cdn/hotspots/base/Icon awesome-plus.svg" 
                    alt="plus-icon" 
                    className="plus-expand-icon"
                />
            }
        </h3>
        <div className={`content ${openSteps && "show"}`}>
          <div className="content-inner">
            <ul className="content-list">
              {props.links.map(link => {
                return(
                  <li key={link.id}>
                    <a href={link.url} target="_blank">{link.label}</a>
                  </li>
                )})
              }
            </ul>
          </div>
        </div>
    </div>
  )
}

export default InfoCard;